module.exports = __webpack_public_path__ + "static/media/Brienne of Tarth 3.5e7c2532.jpg";